import React, { useState, useEffect, useMemo, useRef } from 'react';
import Warning from '../warning/warning';
import HowToPlay from '../howToPlay/howToPlay';
import Play from '../play/play';
import GalleryVN from '../galleryVN/galleryVN';
import NovelMenu from '../novelMenu/novelMenu';
import Credits from '../credits/credits';
import plot from '../../services/plot';
import loading from'../../images/loading.gif'
import achievements from'../../services/achievements'

function App() {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [navigation, setNavigation] = useState( isLS ? localStorage.getItem('navigationSC1') === null ? 0 : parseInt(localStorage.getItem('navigationSC1')) : 0);
  const [step, setStep] = useState( isLS ? localStorage.getItem('stepSC1') === null? 0 : parseInt(localStorage.getItem('stepSC1')) : 0 );
  const [gallery, setGallery] = useState( isLS ? localStorage.getItem('gallerySC') === null ? 0 : new Map(JSON.parse(localStorage.getItem('gallerySC'))) : 0);
  const [howToPlayGuide, setHowToPlayGuide] = useState(isLS ? localStorage.getItem('howToPlayGuideSC') === null ? 0 : JSON.parse(localStorage.getItem('howToPlayGuideSC')) : 0);
  let state = useRef(isLS ? localStorage.getItem('stateSC1') === null ? new Array() : JSON.parse(localStorage.getItem('stateSC1')) : new Array());
  let achievementsSave = useRef(isLS ? localStorage.getItem('achievementsSave') === null ? achievements : JSON.parse(localStorage.getItem('achievementsSave')) : achievements);
  let defaultMenu = useRef(false);
  const [hzAdjuster, setHzAdjuster] = useState(false);



  useEffect(() => {
    detectRefreshRate().then((rate) => {
      rate=100/roundFive(rate);
      setHzAdjuster(rate);
    });
    const map = new Map();
    if(/*gallery === 0*/true){
      for(let key in plot){
        if(plot[key].plot){
        for(let k in plot[key].plot){
          if(plot[key].plot[k].img && plot[key].plot[k].gallery){
        map.set(plot[key].plot[k].img, '0');
        }
        }
        }
        if(plot[key].plotAlt){
        for(let k in plot[key].plotAlt){
          if(plot[key].plotAlt[k].img && plot[key].plotAlt[k].gallery){
        map.set(plot[key].plotAlt[k].img, '0');
        }
        }
        }
        if(plot[key].messages){
        for(let k in plot[key].messages){
          if(plot[key].messages[k].img && plot[key].messages[k].gallery){
        map.set(plot[key].messages[k].img, '0');
        }
        }
        }
        if(plot[key].messagesAlt){
        for(let k in plot[key].messagesAlt){
          if(plot[key].messagesAlt[k].img && plot[key].messagesAlt[k].gallery){
        map.set(plot[key].messagesAlt[k].img, '0');
        }
        }
        }
        if(plot[key].blkscrn && plot[key].chapter){
        map.set("chapter"+plot[key].chapter,"Chapter "+plot[key].chapter);
        }
      }
    }
    if(isLS){
    localStorage.setItem('gallerySC', JSON.stringify(Array.from(map.entries())));
    if(step == 0){
      localStorage.setItem('stepSC1', step);
    }
    }
    setGallery(map);
},[]);

useMemo(() => {
  for(let i = 0;i<achievements.length;i++){
    if(achievementsSave.current[i] && achievementsSave.current[i][1] !== achievements[i][1]){
      achievementsSave.current[i][1] = achievements[i][1];
    }else if(!achievementsSave.current[i]){
      achievementsSave.current.splice(i, 1, achievements[i]);
    }
  }
  if(isLS){
  localStorage.setItem('achievementsSave', JSON.stringify(achievementsSave.current));
}
  if(step>=plot.length-1){
    setNavigation(1);
    defaultMenu.current = true;
  }
}, []);

  function goPlay(){
setTimeout(go,300);
    function go(){
    if(isLS){
    localStorage.setItem('navigationSC1', 2);
    }
    setNavigation(2);
  }
  }
  function goMenu(){
    if(isLS){
    localStorage.setItem('navigationSC1', 1);
    }
    setNavigation(1);
  }
  function goToGallery(){
    if(isLS){
    localStorage.setItem('navigationSC1', 4);
    }
    setNavigation(4);
  }
  function goToCredits(){
    if(isLS){
    localStorage.setItem('navigationSC1', 5);
    }
    setNavigation(5);
  }
  function detectRefreshRate() {
      return new Promise((resolve) => {
          const frameTimes = [];
          const framesToMeasure = 70;

          function measureFrame(startTime) {
              requestAnimationFrame((endTime) => {
                  frameTimes.push(endTime - startTime);

                  if (frameTimes.length < framesToMeasure) {
                      measureFrame(endTime);
                  } else {
                      // Calculate average frame duration
                      const avgFrameTime = frameTimes.reduce((a, b) => a + b, 0) / frameTimes.length;
                      const refreshRate = Math.round(1000 / avgFrameTime);
                      resolve(refreshRate);
                  }
              });
          }

          measureFrame(performance.now());
      });
  }
  function roundFive(num){
    let n = num % 10;
    if(n>=5){
      if(n>7.5){
        return num - n + 10;
      }else if(n<=7.5){
        return num - n+5;
      }
    }else if(n<5){
      if(n>2.5){
        return num - n + 5;
      }else if(n<=2.5){
        return num - n;
      }
    }
  }

if(!hzAdjuster){
  return <div style={{display:"flex", width:"100vw", height:"100vh", justifyContent:"center", alignItems:"center"}}><img src={loading} style={{ width:"30vw"}}/></div>;
}
  if(navigation !== null && navigation === 1){
    return (
      <NovelMenu goPlay={goPlay} goToGallery={goToGallery} goToCredits={goToCredits} step={step} setStep={setStep} state={state} achievementsSave={achievementsSave} plot={plot} defaultMenu={defaultMenu.current} hzAdjuster={hzAdjuster}/>
  );
  }

  if(navigation !== null && navigation === 2 && howToPlayGuide == 0){
    return (
      <HowToPlay  setHowToPlayGuide={setHowToPlayGuide} />
  );
  }


  if(navigation !== null && navigation === 2 && howToPlayGuide !== 0){
    return (
      <Play step={step} state={state} setStep={setStep} goMenu={goMenu} achievementsSave={achievementsSave} hzAdjuster={hzAdjuster}/>
  );
  }
  if(navigation !== null && navigation === 3){

}
  if(navigation !== null && navigation === 4){
    return (
      <GalleryVN goMenu={goMenu} gallery={gallery}/>
  );
  }
  if(navigation !== null && navigation === 5){
    return (
    <Credits goMenu={goMenu} hzAdjuster={hzAdjuster}/>
  );
  }
  if(navigation !== null && navigation === 0){
    return (
      <Warning  goNext={goMenu} />
  );
  }

}

export function IsLSWork(){
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
}

export default App;
